import { render, staticRenderFns } from "./DialogResetPassword.vue?vue&type=template&id=fe223ba2&scoped=true&"
import script from "./DialogResetPassword.vue?vue&type=script&lang=js&"
export * from "./DialogResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./DialogResetPassword.vue?vue&type=style&index=0&id=fe223ba2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe223ba2",
  null
  
)

export default component.exports